import { IMG_SIZE } from 'utils/homologacion/contants';
import { getContentListV1 } from 'utils/homologacion/homologacion';

export const getGridPrimaryImage = (contentInfo, isMobile) => {
  const desktopImg = contentInfo?.image_highlight
    ? contentInfo?.image_highlight
    : contentInfo?.image_base_horizontal;

  return isMobile ? contentInfo?.image_medium : desktopImg;
};

export const getGridDynamicImage = (contentList = [], isMobile = false) => {
  const item = contentList?.[0];
  const length = contentList.length;

  let size;

  if ([4].includes(length) || contentList.length > 4) {
    size = isMobile ? IMG_SIZE.LARGE : IMG_SIZE.VERTICAL;
  } else if ([1, 3, 4].includes(length)) {
    size = isMobile ? IMG_SIZE.LARGE : IMG_SIZE.HORIZONTAL;
  } else if (length === 2) {
    size = isMobile ? IMG_SIZE.MEDIUM : IMG_SIZE.VERTICAL;
  } else {
    size = isMobile ? IMG_SIZE.HORIZONTAL : IMG_SIZE.VERTICAL;
  }

  return getContentListV1?.getImage(item, size);
};

export const getGridSecondaryImage = (
  contentList = [],
  position,
  isMobile = false,
) => {
  const item = contentList?.[position];
  const length = contentList.length;

  if (position === 1 && length === 2) {
    const size = isMobile ? IMG_SIZE.MEDIUM : IMG_SIZE.VERTICAL;
    return getContentListV1?.getImage(item, size);
  }

  if (
    (position === 1 || position === 2) &&
    [2, 3, 4, 5, 6, 7].includes(length)
  ) {
    const size = isMobile ? IMG_SIZE.MEDIUM : IMG_SIZE.HORIZONTAL;
    return getContentListV1?.getImage(item, size);
  }

  if (position === 3) {
    return getContentListV1?.getImage(item, IMG_SIZE.HORIZONTAL);
  }

  return getContentListV1?.getImage(item, IMG_SIZE.HORIZONTAL);
};

export const shouldRenderOverlayImage = (
  contentList,
  position,
  isMobile = false,
) => {
  const length = contentList.length;

  if (position === 1 && length === 2) return false;

  if (
    (position === 1 || position === 2) &&
    [2, 3, 4, 5, 6, 7].includes(length)
  ) {
    return isMobile ? false : true;
  }

  if (position === 3) {
    return true;
  }

  return true;
};

export const shouldRenderDynamicOverlayImg = (
  contentList,
  isMobile = false,
) => {
  const length = contentList.length;

  let displayOverlay;

  if ([1, 3, 4].includes(length)) {
    displayOverlay = true;
  } else if (length === 2) {
    displayOverlay = false;
  } else {
    displayOverlay = isMobile ? true : false;
  }

  return displayOverlay;
};
